import axios from '@/utils/request'

export default {
    // 2020-09-04
    insertBatch(userId, params) {
        return axios.post('/permissions/insert-batch/' + userId, params)
    },
    // // 02-01
    // findByUserId(userId) {
    //     return axios.get('/permissions/find-by-user-id/' + userId)
    // }
}
